/**
 * Default theme that loads when no user preference is set
 * Change this value to set a different default theme
 */
export const DEFAULT_THEME = 'safha';

export const THEMES = [
  {
    name: 'Safha',
    value: 'safha'
  },
  {
    name: 'Safha Soft',
    value: 'safha-soft'
  },
  {
    name: 'Claude',
    value: 'claude'
  },
  {
    name: 'Papyrus',
    value: 'papyrus'
  },
  {
    name: 'Manuscript',
    value: 'manuscript'
  },
  {
    name: 'Inkwell',
    value: 'inkwell'
  },
  {
    name: 'Desert',
    value: 'desert'
  },
  {
    name: 'Mono',
    value: 'mono'
  }
];
